import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { upperCaseFirstLetter } from '../../../../helpers/common'
import {
  applyCriteria,
  selectApplyingCriteria,
} from '../../selectCriteria/store/slice'
import { selectCriteriaById, selectFilter } from '../store/slice'
import { deleteSavedCriteria, getSavedCriterias } from '../store/thunk'

export const DeleteCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const filter = useSelector(selectFilter())
  const criteriaName = useSelector(
    selectCriteriaById(rowId, 'screeningSavedCriteriaName'),
  )
  const applyingCriteria = useSelector(selectApplyingCriteria())

  const [isShow, setIsShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleOpen = (e) => {
    e?.stopPropagation()
    setIsShow(true)
  }

  const handleClose = (e) => {
    e?.stopPropagation()
    if (isLoading) return
    setIsShow(false)
  }

  const handleDelete = (e) => {
    e?.stopPropagation()
    if (isLoading) return

    setIsLoading(true)

    dispatch(deleteSavedCriteria({ Id: rowId }))
      .unwrap()
      .then(() => {
        if (applyingCriteria && applyingCriteria.id === rowId) {
          dispatch(applyCriteria(null))
        }

        const { keyword, from, to, page, pageSize, sortBy, sortDirection } =
          filter
        const params = { Page: page, PageSize: pageSize }
        if (keyword) params.Name = keyword
        if (from) params.FromDate = from
        if (to) params.ToDate = to
        if (sortBy && sortDirection) {
          params.Sort = upperCaseFirstLetter(sortBy)
          params.SortDirection = sortDirection
        }
        dispatch(getSavedCriterias(params))
        handleClose()
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
      })
  }

  return (
    <Element>
      <Icon
        className="icon-trash-fill"
        style={{ fontSize: 15, color: '#D5D5D5' }}
        onClick={handleOpen}
      />
      <PopupAction
        isShow={isShow}
        title="screening.DELETE_CRITERIA"
        btnCancel={{
          label: 'screening.CANCEL',
          isI18n: true,
          event: handleClose,
          disabled: isLoading,
        }}
        btnSubmit={{
          label: 'screening.DELETE',
          isI18n: true,
          event: handleDelete,
          disabled: isLoading,
        }}
        handleClose={handleClose}
      >
        <Element className="textCenter pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate
              value="screening.DELETE_CRITERIA_MESS"
              name={criteriaName}
              dangerousHTML
              className="breakWord"
            />
          </Element>
        </Element>
      </PopupAction>
    </Element>
  )
}
